import Kogi from './Kogi';

export default {
  Kogi,
};
